<template>
  <div class="news-box content-1200">
    <div class="text-center font-blod color-level1 margin-b20 fontSize36">资讯动态</div>
    <div class="text-center color-level2 fontWeight-500 fontSize18 margin-b60">
      实时联盟资讯，权威行业宣导，赋能创新突破
    </div>
    <el-row  class="news margin-b40">
      <el-col :xs="24" :sm="12">
        <div class="news-left relative W100 margin-r40">
          <img class="W100 H100 radius-8" :src="hotItem.imageUrl" alt="">
          <div class="desc W100 absolute flex-start space-between">
            <div class="min-width-0 flex1 color-main1 font-blod fontSize18 ellipsis" :title="hotItem.title">{{ hotItem.title }}</div>
            <span class="more color-level4" @click="$router.push({path:'/home/news/info',query: {newsId:hotItem.id}})">了解详情
              <i></i>
            </span>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" >
        <ul class="news-right min-width-0 W100">
          <li v-for="item in news" :key="item.id" class="flex-nowrap">
            <img class="radius-8" :src="item.imageUrl" alt="">
            <div class="desc W100 flex-column space-between">
              <span class="color-level1 ellipsis" :title="item.title">{{ item.title }}</span>
              <span class="more color-level2" @click="$router.push({path:'/home/news/info',query: {newsId:item.id}})">了解详情
                  <i></i>
                </span>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
    <!-- <div class="news flex-nowrap margin-b40">
      <div class="news-left relative margin-r40">
        <img class="W100 H100 radius-8" :src="hotItem.imageUrl" alt="">
        <div class="desc W100 absolute flex-start space-between">
          <div class="min-width-0 flex1 color-main1 font-blod fontSize18 ellipsis" :title="hotItem.title">{{ hotItem.title }}</div>
          <span class="more color-level4" @click="$router.push({path:'/home/news/info',query: {newsId:hotItem.id}})">了解详情
            <i></i>
          </span>
        </div>
      </div>
      <ul class="news-right min-width-0 flex1">
        <li v-for="item in news" :key="item.id" class="flex-nowrap">
          <img class="radius-8" :src="item.imageUrl" alt="">
          <div class="desc W100 flex-column space-between">
            <span class="color-level1 ellipsis" :title="item.title">{{ item.title }}</span>
            <span class="more color-level2" @click="$router.push({path:'/home/news/info',query: {newsId:item.id}})">了解详情
                <i></i>
              </span>
          </div>
        </li>
      </ul>
    </div> -->
    <more-button @handleClick="$router.push('/home/news/list')"/>
  </div>
</template>
<script>
import MoreButton from "@/components/common/MoreButton";

export default {
  components: {MoreButton: MoreButton},
  props: {
    newsList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    newsList(newVal) {
      if (newVal.length > 0) {
        this.hotItem = newVal[0]
        this.news = newVal.slice(1)
        console.log(this.hotItem);
        console.log(this.news);
      }
    }
  },
  data() {
    return {
      hotItem: {}, // 左侧热门
      news: [] //右侧列表
    }
  }
}
</script>
<style scoped lang="scss">
.news-box {
  padding: 80px 0 40px;

  .news {
    &-left {
      // width: 600px;
      // height: 400px;

      .desc {
        padding: 0 20px 0 24px;
        height: 60px;
        bottom: 0;
        background: rgba(18, 21, 26, 0.75);
        border-radius: 0 0 8px 8px;
      }
    }

    &-right {
      padding: 20px;
      padding-top: 3px;

      li {
        & > img {
          width: 120px;
          height: 80px;
          margin-right: 20px;
        }

        &:not(:last-of-type) {
          margin-bottom: 26px;
        }

        .desc {
          flex: 1;
          padding: 5px 0;
          min-width: 0;
        }
      }
    }

    .more {
      display: flex;
      align-items: center;
      cursor: pointer;
      width: 79px;

      i {
        display: block;
        margin-left: 3px;
        width: 20px;
        height: 20px;
        background-image: url("~@/assets/img/common/more.png");
        background-size: 20px 20px;
        background-repeat: no-repeat;
      }

      img {
        margin-left: 3px;
        width: 20px;
        height: 20px;
      }

      &:hover {
        color: $color-main2;

        i {
          background-image: url("~@/assets/img/common/more-active.png");
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .news-box{
    .news-right {
      padding-top:20px;
    }
  }
}
</style>
